import { Trans, useTranslation } from "react-i18next";

export default function FAQ({}) {
  return (
    <>
    <div style={{display: "flex", flexDirection: "column", gap: "20px", alignItems: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <h4 className="FAQ-header" style={{textAlign: "center"}}><Trans i18nKey="terms.header" /></h4>
        </div>
        <div style={{display: "flex", flexDirection: "column", gap: "24px", alignItems: "center", width: "100%"}}> 
            <div style={{display: "flex", flexDirection: "column", gap: "12px", alignItems: "start", width: "100%"}}>
                <h2 className="terms-header"><Trans i18nKey="terms.first.header" /></h2>
                <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "start", width: "100%"}}>
                    <p className="terms-text"><Trans i18nKey="terms.first.1" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.2" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.3" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.4" components={{ highlight: <span className="highlight" /> }}/></p>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "12px", alignItems: "start", width: "100%"}}>
                <h2 className="terms-header"><Trans i18nKey="terms.first.header" /></h2>
                <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "start", width: "100%"}}>
                    <p className="terms-text"><Trans i18nKey="terms.first.1" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.2" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.3" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.4" components={{ highlight: <span className="highlight" /> }}/></p>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "12px", alignItems: "start", width: "100%"}}>
                <h2 className="terms-header"><Trans i18nKey="terms.first.header" /></h2>
                <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "start", width: "100%"}}>
                    <p className="terms-text"><Trans i18nKey="terms.first.1" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.2" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.3" components={{ highlight: <span className="highlight" /> }}/></p>
                    <p className="terms-text"><Trans i18nKey="terms.first.4" components={{ highlight: <span className="highlight" /> }}/></p>
                </div>
            </div>
        </div>
    </div>
    </>
  );
}